import { UserService } from './../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef, ViewChild  } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  menuList:any;
  pageList:any;
  @ViewChild('panel', { read: ElementRef }) public panel;
  constructor(private service: UserService, private router: Router, private route: ActivatedRoute) { }
  

  ngOnInit() {

  if (+localStorage.getItem('First')== 1)
  {
    window.location.reload()
    localStorage.removeItem('First')
  }    

    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Home')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }
  public scrollDivLeft():void{    
    this.panel.nativeElement.scrollLeft -= 100;
  }
  
  public scrollDivRight():void {
    this.panel.nativeElement.scrollLeft += 100;
  }
  NavigateUrl(URL: any) {
    debugger;
    if (URL) {
      this.router.navigate([URL]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts